export const buttonStateMapping = {
    error: {
        variant: 'solidRed',
        iconProps: {
            animation: 'fadeDown',
            icon: 'falTimesCircle'
        }
    },
    loading: {
        variant: 'primaryDark',
        iconProps: {
            animation: 'vui-spin 0.6s linear infinite',
            name: 'fadSpinnerThird',
            pathFill: ['', 'transparent']
        }
    },
    success: {
        variant: 'solidGreen',
        iconProps: {
            animation: 'fadeDown',
            icon: 'falCheckCircle'
        }
    }
};
